import React from 'react';
import Geography from "./Geography";
import Management from "./Management";
import {connect} from "react-redux";
import {setGeoChoice} from "../../../actions/CreateSiteActions/dimensionActions";
import {ChoiceGroup} from '@fluentui/react';
import InfoTooltip from '../../formFields/InfoTooltip';
import Warning from "../CommonComponents/Warning";

const CROSS_ORGANIZATION = { key:'Cross', value: 'Cross Organisation' };

class CombineSteps extends React.Component {

    constructor() {
        super();
        this.state= {crossOrganisation : null}
    }

    componentDidMount(): void {
        if ((this.props.selectedGeo && this.props.selectedGeo.key === CROSS_ORGANIZATION.key)
            || (this.props.geographyConfig.defaultKey && this.props.geographyConfig.defaultKey === CROSS_ORGANIZATION.key)) {
                
            this.setState({crossOrganisation: true});
            this.props.setGeography(CROSS_ORGANIZATION);
        }
        else if (this.props.selectedGeo 
            || (this.props.geographyConfig.defaultKey && this.props.geographyConfig.defaultKey !== CROSS_ORGANIZATION.key)
            || this.props.geographyConfig.isCrossOrgDisabled) {
            this.setState({crossOrganisation: false});
        }
    }

    isCountryRegionOrganization() {
        return this.state.crossOrganisation === false;
    }

    isCrossOrganization() {
        return this.state.crossOrganisation;
    }

    onCrossOrganizationSelect = (e, option) => {
        this.setState({crossOrganisation: option.key});
        this.props.setGeography(option.key ? CROSS_ORGANIZATION : null);
    }

    isValid() {
        return this.state.crossOrganisation !== null;
    }

    render() {
        const warning = this.props.possibleWarning && !this.isValid() ?  <Warning element=""/> : null;
        const error = warning && <div className='errorMessage'>Please select an option</div>;
        
        const toolTip = "Select for whom Site is dedicated for.";
        const toolTipIATU = "Select to which country the project is related (for global projects, select Switzerland)";
        
        return (
            <div>
                <Management/>
                <div className="audience-panel">
                    {warning}
                    Select Site Audience
                    <InfoTooltip content={this.props.isIATU || this.props.isIAPCP ? toolTipIATU : toolTip} />
                    <ChoiceGroup
                        options={[
                            {
                                key: false,
                                text: 'Country/Region'
                            },
                            {
                                key: true,
                                text: 'Cross Organisation'
                            }
                        ]}
                        onChange={this.onCrossOrganizationSelect}
                        selectedKey={this.isCrossOrganization()}
                        disabled = {this.props.geographyConfig.isDisabled || this.props.geographyConfig.isCrossOrgDisabled}
                    />
                    {error}
                </div>
                <br />
                {   
                    this.isCountryRegionOrganization() &&
                    <div>
                        <Geography possibleWarning={true} />
                    </div>
                }
                    
            </div>
        );
    }
}


const mapActionToProp = {
    setGeography: setGeoChoice
}

const mapStateToProps = state => ({
    selectedGeo: state.newSite.geography,
    possibleWarning: state.wizard.nextStepRequested,
    isIATU: state.newSite.isIATU,
    isIAPCP: state.newSite.isIAPCP,
    geographyConfig: (state.newSite.Template.config || {}).geographyConfig || {}
})


export default connect(mapStateToProps, mapActionToProp)(CombineSteps)






// WEBPACK FOOTER //
// ./src/components/CreateSite/Step3/CombineSteps.js